import { render, staticRenderFns } from "./EditIntentExample.vue?vue&type=template&id=0570cfba"
import script from "./EditIntentExample.vue?vue&type=script&lang=js"
export * from "./EditIntentExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports